<div id="content" #content>
  @for (ticket of ticketToShow?.tickets; track ticket; let i = $index) {
    @if (isMobile) {
      <div class="card d-flex justify-content-center">
        <div class="code-box d-flex justify-content-center mb-5 mt-2">
          <div class="barcode d-flex flex-column text-center">
            <div class="code-img">
              <qrcode class="qr-code" [qrdata]="ticket?.content" [width]="150" [errorCorrectionLevel]="'L'">
              </qrcode>
            </div>
            <h1 class="name">
              {{ ticket?.customerName }}
            </h1>
            <h4 class="code">
              {{ ticket?.ticketNumber }}
            </h4>
            <div class="seat d-flex justify-content-center">
              <div class="seat-number me-2">
                {{ ticketToShow?.trainTripSchedule }}
              </div>
              <div class="seat-number">
                {{ ticket?.productLabel }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-between">
            <p>
              {{
              ticketToShow?.startTime
              | scDatePipe : "date"
              | date : "d LLLL YYYY"
              }}
            </p>
            <p>
              {{
              getTimeDifference(
              ticketToShow?.startTime,
              ticketToShow?.endTime
              )
              }}
            </p>
          </div>
          <hr />
          <div>
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-between">
                <p class="train-times">
                  {{ ticketToShow?.startTime | scDatePipe : "time" }}
                </p>
                <p class="train-times">
                  {{ ticketToShow?.endTime | scDatePipe : "time" }}
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <h1 class="station-name">
                  {{ ticketToShow?.sourceLogicalStation | slice : 0 : 3 }}
                </h1>
                <h1 class="station-name">
                  {{ ticketToShow?.destinationLogicalStation | slice : 0 : 3 }}
                </h1>
              </div>
              <div class="d-flex justify-content-between">
                <p>
                  {{ ticketToShow?.sourceLogicalStation }}
                </p>
                <p>
                  {{ ticketToShow?.destinationLogicalStation }}
                </p>
              </div>
            </div>
            <hr />
          </div>
          <div class="d-flex justify-content-between">
            <p>
              {{ ticket?.coach }}
            </p>
            <p>
              {{ ticket?.seat }}
            </p>
          </div>
        </div>
      </div>
    } @else {
      <div class="ticket-card">
        <div class="ticket-head">
          <h2 class="ticket-sub-heading">Breeze</h2>
          <span class="ticket-class"> {{ ticket.coachType }} class </span>
        </div>
        <div class="grid">
          <div class="time-container">
            <div class="depart">
              <span class="travel-title"> Depart </span>
              <span class="travel-time">
                {{ ticketToShow?.startTime | scDatePipe : "time" }}
              </span>
              <p class="travel-date">
                {{
                ticketToShow?.startTime
                | scDatePipe : "date"
                | date : "d LLLL YYYY"
                }}
              </p>
            </div>
            <div class="duration-container">
              <img src="../../../../assets/blue-dot.svg" alt="" />
              <span class="duration">
                {{
                getTimeDifference(
                ticketToShow?.startTime,
                ticketToShow?.endTime
                )
                }}
              </span>
              <img src="../../../../assets/blue-dot.svg" alt="" />
            </div>
            <div class="arrive">
              <span class="travel-title"> Arrive </span>
              <span class="travel-time">
                {{ ticketToShow?.endTime | scDatePipe : "time" }}
              </span>
              <p class="travel-date">
                {{
                ticketToShow?.endTime
                | scDatePipe : "date"
                | date : "d LLLL YYYY"
                }}
              </p>
            </div>
          </div>
          <div class="bio-container">
            <div class="passenger-info">
              <div class="passenger-item">
                <span class="passenger-details-title"> Name </span>
                <span class="passenger-details-value">
                  {{ ticket?.customerName }}
                </span>
              </div>
              <div class="passenger-item">
                <span class="passenger-details-title"> Product </span>
                <span class="passenger-details-value">
                  {{ ticket?.productLabel }}
                </span>
              </div>
              <div class="passenger-item">
                <span class="passenger-details-title"> Ticket Number </span>
                <span class="passenger-details-value">
                  {{ ticket?.ticketNumber }}
                </span>
              </div>
              <div class="passenger-item">
                <span class="passenger-details-title"> Trip Code </span>
                <span class="passenger-details-value">
                  {{ ticketToShow?.trainTripSchedule }}
                </span>
              </div>
            </div>
            <qrcode class="qr-code" [qrdata]="ticket?.content" [width]="150" [errorCorrectionLevel]="'L'"></qrcode>
          </div>
          <div class="info-container">
            <div class="ticket-info">
              <img src="/assets/icon-ticket.svg" alt="" />
              <span>
                Show e-tickets and passenger identities during check-in.
              </span>
            </div>
            <div class="time-info">
              <img src="/assets/icon-clock.svg" alt="" />
              <span>
                Please be at the boarding gate at least 30 minutes before
                boarding time.
              </span>
            </div>
          </div>
          <div class="others-container">
            <div class="seat-box">
              <span class="seat-title"> Coach </span>
              <span class="seat-value">
                {{ ticket?.coach }}
              </span>
            </div>
            <div class="seat-box">
              <span class="seat-title"> seat </span>
              <span class="seat-value">
                {{ ticket?.seat }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  }
  <div class="breeze-banner-container px-3 px-lg-5 ms-lg-auto me-lg-5">
    <img src="assets/peak-ad.png" alt="Pay with transfer on Breeze - Super Fast" class="breeze-banner-img" />
    <!-- <img
    src="assets/landing-page-assets/SecurePay.png"
    alt="Pay with transfer on Breeze - Super Fast"
    class="breeze-banner-img"
    /> -->
  </div>
</div>

@if (showDownload) {
  <div class="dont-show d-flex align-items-center justify-content-center flex-column my-5">
    <button (click)="onDownload()" class="btn prjct-btn">Download</button>
  </div>
}